import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import {
  CONTENT_IS_EMPTY,
  ENV_TYPE,
  FLEX_ACTION_TYPE,
  IMAGE_ERROR_DIMENSIONS,
  IMAGE_ERROR_EXTENSION,
  IMAGE_ERROR_NOT_FOUND,
  MESSAGE_TYPE,
  STATUS,
  USER_TYPE,
  MAX_LIMIT_NAME,
  NAME_IS_OVERLIMIT,
  MAX_LIMIT_DESCRIPTION,
  DESCRIPTION_IS_OVERLIMIT,
  MAX_LIMIT_LABEL,
  LABEL_IS_OVERLIMIT,
} from '../../../../constants/abuddy.constants';
import { AWSelect, Back, Create, Wrong } from '../../../../helpers';
import {
  addLibraryCategory,
  // getContentNames,
  uploadImageContent,
} from '../../../../services/libraryService/libraryCategory.service';
import '../../../Abuddy/Abuddy.scss';
import SelectContentModal from './SelectContentModal';

class LibrarySubCategoryCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      label: '',
      error: [],
      status: '',
      imageFlex: '',
      oaDisplay: '',
      hidden: false,
      visible: false,
      actionType: '',
      description: '',
      messageType: '',
      actionDetail: '',
      selectedImage: '',
      ImageError: false,
      typeImage: ['jpg', 'png'],
      contentNames: [],
      contents: [],
    };

    this.logFile = this.logFile.bind(this);
    this.logChange = this.logChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onActionDescChange = this.onActionDescChange.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.setContents = this.setContents.bind(this);
  }

  onCloseModal() {
    this.setState({ isModalOpen: false });
  }

  setContents(contents) {
    this.setState({ contents });
  }

  logChange(e) {
    if (e.target.name === 'actionType') {
      this.setState({
        label: '',
        actionDetail: '',
        [e.target.name]: e.target.value,
      });
      return;
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  onActionDescChange(e) {
    const value = e.target.value;
    this.setState({
      actionDetail: value,
      label: value.label.keyword.replace('#', ''),
    });
  }

  logFile(e) {
    const file = e.target.files ? e.target.files[0] : null;
    const typeImage = this.state.typeImage;
    let that = this;
    var _URL = window.URL || window.webkitURL;

    if (file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        document.getElementById('cover').setAttribute('src', e.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);

      let img = new Image();
      img.onload = function () {
        if (
          typeImage.find((type) => file.name.split('.').pop() === type)
            ? false
            : true
        ) {
          that.setState({
            visible: true,
            message: IMAGE_ERROR_EXTENSION,
            ImageError: true,
          });
        } else if (this.width !== 600 || this.height !== 600 ? true : false) {
          that.setState({
            visible: true,
            message: IMAGE_ERROR_DIMENSIONS,
            ImageError: true,
          });
        } else {
          that.setState({ visible: false, message: '', ImageError: false });
        }
      };
      img.onerror = function () {
        that.setState({
          visible: true,
          message: IMAGE_ERROR_EXTENSION,
          ImageError: true,
        });
      };
      img.src = _URL.createObjectURL(file);
    }

    this.setState({ [e.target.name]: file });
  }

  async handleSubmit(e) {
    try {
      window.scrollTo(0, 0);
      this.setState({
        hidden: true,
        envType: ENV_TYPE.LIB_SUB_CATEGORY,
        actionType: FLEX_ACTION_TYPE.CONTENT,
      });

      if (this.state.ImageError) {
        this.setState({
          visible: true,
          message: IMAGE_ERROR_EXTENSION,
          ImageError: true,
          hidden: false,
        });
        return;
      }

      if (this.state.name.length > MAX_LIMIT_NAME) {
        this.setState({
          hidden: false,
          visible: true,
          message: NAME_IS_OVERLIMIT,
        });
        return;
      }

      if (this.state.description.length > MAX_LIMIT_DESCRIPTION) {
        this.setState({
          hidden: false,
          visible: true,
          message: DESCRIPTION_IS_OVERLIMIT,
        });
        return;
      }

       if (this.state.label.length > MAX_LIMIT_LABEL) {
        this.setState({
          hidden: false,
          visible: true,
          message: LABEL_IS_OVERLIMIT,
        });
        return;
      }

      let actionDetail = this.state.actionDetail;

      if (!this.state.imageFlex) {
        this.setState({
          visible: true,
          hidden: false,
          message: IMAGE_ERROR_NOT_FOUND,
        });
        return;
      }

      const imageFlexPath = await this.getUploadImagePath(this.state.imageFlex);

      if (this.state.actionType === FLEX_ACTION_TYPE.CONTENT) {
        if (this.state.contents.length === 0) {
          this.setState({
            visible: true,
            hidden: false,
            message: CONTENT_IS_EMPTY,
          });
          return;
        }
        const contents = this.state.contents.map((value, index) => {
          return {
            name: value.name,
            orderNo: index + 1,
            contentId: value._id,
          };
        });
        actionDetail = contents;
      }

      const flex = {
        label: this.state.name,
        actionDetail,
        name: this.state.name,
        imageFlex: imageFlexPath,
        status: this.state.status,
        envType: ENV_TYPE.LIB_SUB_CATEGORY,
        oaDisplay: USER_TYPE.ABO,
        actionType: FLEX_ACTION_TYPE.CONTENT,
        description: this.state.description,
        messageType: MESSAGE_TYPE.FLEX_IMAGE,
      };

      await addLibraryCategory(flex);
      this.setState({ hidden: false });
      this.props.history.push('/library/sub-category');
    } catch (err) {
      console.log(err);
      this.setState({ hidden: false });
      if (err.response) {
        const { message, error } = err.response.data;

        if (message instanceof Object) {
          this.setState({ error: message });
        } else {
          this.setState({
            visible: true,
            message: message ? message : error,
          });
        }
      } else {
        this.setState({ visible: true, message: err.message });
      }
    }
  }

  onOpenModal(e) {
    e.preventDefault();
    this.setState({ isModalOpen: true });
  }

  async getUploadImagePath(imageFile) {
    let formData = new FormData();
    formData.append('imageFile', imageFile);
    formData.append('name', 'flex');
    const uploadResponse = await uploadImageContent(formData);
    const imageLink = uploadResponse.imageLink;
    return imageLink;
  }

  render() {
    const { error, imageFlex, contentNames } = this.state;
    return (
      <div className="product-create-container animated fadeIn">
        <SelectContentModal
          isOpen={this.state.isModalOpen}
          onClose={this.onCloseModal}
          callback={this.setContents}
        />
        <Row>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <Create />
                <strong className="ml-2"> Create Sub Category</strong>
              </CardHeader>
              <LoadingOverlay active={this.state.hidden} spinner>
                <CardBody>
                  <Alert color="danger" isOpen={this.state.visible}>
                    <Wrong className="mr-1" />
                    {this.state.message}
                  </Alert>
                  <Form
                    action=""
                    method="post"
                    encType="multipart/form-data"
                    className="form-horizontal"
                  >
                    <FormGroup row>
                      <Col md="3">
                        <Label htmlFor="name">Card Overview</Label>
                      </Col>
                      <Col md="9">
                        <Label htmlFor="name">Name:</Label>
                        <Input
                          type="text"
                          name="name"
                          invalid={
                            error.find((value) => value.property === 'name') &&
                            true
                          }
                          value={this.state.name}
                          onChange={this.logChange}
                        />
                        {error.find((value) => value.property === 'name') && (
                          <FormFeedback>
                            {Object.values(
                              error.find((value) => value.property === 'name')
                                .constraints,
                            ).map((val, i) => {
                              return (
                                <div key={i}>
                                  <Wrong
                                    className="mr-1"
                                    style={{ width: '12px' }}
                                  />
                                  {val}
                                </div>
                              );
                            })}
                          </FormFeedback>
                        )}
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3" />
                      <Col md="9">
                        <Label htmlFor="description">Description:</Label>
                        <Input
                          type="text"
                          name="description"
                          invalid={error.find(
                            (value) => value.property === 'description',
                          )}
                          value={this.state.description}
                          onChange={this.logChange}
                        />
                        {error.find(
                          (value) => value.property === 'description',
                        ) && (
                          <FormFeedback>
                            {Object.values(
                              error.find(
                                (value) => value.property === 'description',
                              ).constraints,
                            ).map((val, i) => {
                              return (
                                <div key={i}>
                                  <Wrong
                                    className="mr-1"
                                    style={{ width: '12px' }}
                                  />
                                  {val}
                                </div>
                              );
                            })}
                          </FormFeedback>
                        )}
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3"></Col>

                      <Col xs="12" md="9">
                        <Label htmlFor="type">Image Content:</Label>
                        <br />

                        <label for="imageFlex" className="upload-btn">
                          Choose File
                        </label>
                        <Input
                          id="imageFlex"
                          type="file"
                          name="imageFlex"
                          cover="content"
                          accept=".png,.jpg"
                          invalid={error.find(
                            (value) => value.property === 'imageFlex',
                          )}
                          onChange={this.logFile}
                        />
                        <span className="ml-2">
                          {imageFlex ? imageFlex.name : 'No file chosen'}
                        </span>
                        <p className="text-secondary">
                          *ขนาดรูปภาพ 600 x 600 (.jpg, .png)
                        </p>
                        <img
                          id="cover"
                          src=""
                          alt=""
                          className="img-responsive"
                          hidden={this.state.ImageError}
                          width="20%"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">
                        <Label htmlFor="action">Action</Label>
                      </Col>
                      <Col md="8">
                        <div>
                          <Button
                            className="btn-select-sub-cat"
                            onClick={(e) => this.onOpenModal(e)}
                          >
                            เลือก Content
                          </Button>
                        </div>
                        <div className="mt-10">
                          <Table
                            bordered
                            striped
                            responsive
                            hidden={this.state.hidden}
                          >
                            <tbody>
                              {this.state.contents.map((value) => {
                                return (
                                  <tr
                                    key={value.name}
                                    style={{ marginBottom: 0, marginTop: 10 }}
                                  >
                                    <td>{value.name}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3" />
                      <Col md="9">
                        <Label htmlFor="label">Label:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>#</InputGroupText>
                          </InputGroupAddon>

                          <Input
                            type="text"
                            name="label"
                            prefix="#"
                            invalid={error.find(
                              (value) => value.property === 'label',
                            )}
                            value={this.state.label}
                            onChange={this.logChange}
                          />
                          {error.find(
                            (value) => value.property === 'label',
                          ) && (
                            <FormFeedback>
                              {Object.values(
                                error.find(
                                  (value) => value.property === 'label',
                                ).constraints,
                              ).map((val, i) => {
                                return (
                                  <div key={i}>
                                    <Wrong
                                      className="mr-1"
                                      style={{ width: '12px' }}
                                    />
                                    {val}
                                  </div>
                                );
                              })}
                            </FormFeedback>
                          )}
                        </InputGroup>
                        <p className="text-secondary">
                          *จำนวนตัวอักษรรวม # แล้วไม่เกิน 40 ตัวอักษร
                        </p>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">
                        <Label htmlFor="type">Status</Label>
                      </Col>
                      <Col md="9">
                        <AWSelect
                          type="select"
                          name="status"
                          invalid={error.find(
                            (value) => value.property === 'status',
                          )}
                          value={this.state.status}
                          onChange={this.logChange}
                        >
                          <option value="">เลือกสถานะ</option>
                          <option value={STATUS.PUBLISH}>Publish</option>
                          <option value={STATUS.UNPUBLISH}>Unpublish</option>
                        </AWSelect>
                        {error.find((value) => value.property === 'status') && (
                          <FormFeedback>
                            {Object.values(
                              error.find((value) => value.property === 'status')
                                .constraints,
                            ).map((val, i) => {
                              return (
                                <div key={i}>
                                  <Wrong
                                    className="mr-1"
                                    style={{ width: '12px' }}
                                  />
                                  {val}
                                </div>
                              );
                            })}
                          </FormFeedback>
                        )}
                      </Col>
                    </FormGroup>
                  </Form>
                </CardBody>
                <CardFooter>
                  <Button
                    className="submit-btn ml-1"
                    type="submit"
                    color="primary"
                    onClick={this.handleSubmit}
                  >
                    <i className="iconm-Save"></i> Submit
                  </Button>
                  <Button
                    className="back-btn"
                    onClick={() => {
                      this.props.history.push('/library/sub-category');
                    }}
                    type="reset"
                    style={{ marginLeft: '10px' }}
                  >
                    <Back /> Back
                  </Button>
                </CardFooter>
              </LoadingOverlay>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(LibrarySubCategoryCreate);
